import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Role } from '../roles'
import { formLabelCss } from '../../legacy-design-system/text'
import { RenderRotateKey } from './rotate-keys'
import { useSplitClient } from 'contrastBase/state'
import { AgentKeyType, Field } from './field'
import { css } from '@emotion/css'
import { getOrgUuid } from '../add-agent/download-agent/wizard/common/utils'

export interface OrgApiKeysParentProps {
  readonly apiKey?: string
  readonly role?: Role
  /** Verify if it should validate or not the provided "role" prop in order to show|hide elements in the view */
  readonly checkRole: boolean
  readonly onRotateApiKey: () => void
}

const itemSpaceCss = css`
  margin-bottom: 20px;
  display: block;
`

export const OrganizationApiKey: React.FC<OrgApiKeysParentProps> = ({
  apiKey,
  checkRole,
  role,
  onRotateApiKey
}) => {
  const { isSplitTreatmentOn } = useSplitClient()
  const isMultipleUsersEnabled = isSplitTreatmentOn(
    'PROD-3155_multiple_agent_users'
  )

  const renderContent = () => {
    if (!apiKey) {
      return null
    }

    if (isMultipleUsersEnabled) {
      return (
        <Field
          className={itemSpaceCss}
          label={{ id: 'title_apiKey' }}
          value={apiKey}
          inlineDescription
          description={RenderRotateKey(
            isMultipleUsersEnabled,
            onRotateApiKey,
            checkRole,
            role,
            true
          )}
          testId="api-key"
          isObfuscated
          showObfuscationButton
          orgUuid={getOrgUuid()}
          valueType={AgentKeyType.ApiKey}
        />
      )
    }

    return (
      <>
        <FormattedMessage id="title_apiKey">
          {(text) => <div className={formLabelCss}>{text}</div>}
        </FormattedMessage>
        <span>{apiKey}</span>
        <div>
          {RenderRotateKey(
            isMultipleUsersEnabled,
            onRotateApiKey,
            checkRole,
            role,
            true
          )}
        </div>
      </>
    )
  }

  return <div>{renderContent()}</div>
}
